module.exports = __webpack_public_path__ + "static/media/cwc-logo-full-blue.7c8cc1fb.png";